export type TIconSvg = string;

const icons = {
  filters: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6 14.3219L9.2 15.0838V10.0629C9.19912 9.86298 9.11579 9.67144 8.968 9.52952L3.784 4.52381H16.232L11.056 9.52952C10.9082 9.67144 10.8249 9.86298 10.824 10.0629L10.8 15.9524L12.4 16.7143V10.3752L17.664 5.28571C17.8746 5.08226 17.9949 4.80945 18 4.52381V3.7619C18 3.55984 17.9157 3.36604 17.7657 3.22316C17.6157 3.08027 17.4122 3 17.2 3H2.8C2.58783 3 2.38434 3.08027 2.23431 3.22316C2.08429 3.36604 2 3.55984 2 3.7619V4.52381C2.00512 4.80945 2.12543 5.08226 2.336 5.28571L7.6 10.3752V14.3219Z" fill="#686F90"/>
    </svg>
  `,
  group: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3148 2.60159L13.3152 2.60118C13.45 2.46627 13.675 2.46627 13.8099 2.60118L17.3988 6.19202L17.3992 6.19238C17.4311 6.22428 17.4565 6.26218 17.4738 6.30392C17.4911 6.34566 17.5 6.39042 17.5 6.43562C17.5 6.48083 17.4911 6.52558 17.4738 6.56732C17.4565 6.60907 17.4311 6.64697 17.3992 6.67886L17.3988 6.67922L13.8014 10.2785C13.6666 10.4134 13.45 10.4134 13.3152 10.2785L9.71777 6.67922L9.71741 6.67886C9.68547 6.64697 9.66011 6.60907 9.6428 6.56733C9.6255 6.52558 9.61659 6.48083 9.61659 6.43562C9.61659 6.39042 9.6255 6.34566 9.6428 6.30392C9.6601 6.2622 9.68544 6.22432 9.71736 6.19244C9.71737 6.19242 9.71739 6.1924 9.71741 6.19238L13.3148 2.60159ZM10.9645 17.1531V12.0717C10.9645 11.8818 11.1218 11.7248 11.311 11.7248H16.3897C16.5788 11.7248 16.7361 11.8818 16.7361 12.0717V17.1531C16.7361 17.343 16.5788 17.5 16.3897 17.5H11.311C11.1218 17.5 10.9645 17.343 10.9645 17.1531ZM7.92516 17.5H2.84645C2.65729 17.5 2.5 17.343 2.5 17.1531V12.0717C2.5 11.8818 2.65729 11.7248 2.84645 11.7248H7.92516C8.11432 11.7248 8.27161 11.8818 8.27161 12.0717V17.1531C8.27161 17.343 8.11432 17.5 7.92516 17.5ZM2.5 8.68413V3.60275C2.5 3.41285 2.65729 3.25586 2.84645 3.25586H7.92516C8.11432 3.25586 8.27161 3.41285 8.27161 3.60275V8.68413C8.27161 8.87403 8.11432 9.03103 7.92516 9.03103H2.84645C2.65729 9.03103 2.5 8.87403 2.5 8.68413Z" fill="#686F90" stroke="#686F90"/>
    </svg>
  `,
  columnOptions: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7866 10.784L17.9999 10.2507C17.8764 9.81942 17.7065 9.40277 17.4933 9.00806L18.3679 7.37073C18.4007 7.30893 18.4128 7.23819 18.4022 7.16902C18.3916 7.09984 18.359 7.03592 18.3093 6.98673L17.0346 5.70674C16.9854 5.65696 16.9215 5.62437 16.8523 5.6138C16.7831 5.60324 16.7124 5.61525 16.6506 5.64807L15.0239 6.5174C14.6253 6.29376 14.2032 6.11489 13.7653 5.98407L13.232 4.21875C13.2094 4.15369 13.1668 4.09747 13.1102 4.05817C13.0537 4.01888 12.9861 3.99854 12.9173 4.00008H11.1146C11.0454 4.0004 10.978 4.02282 10.9224 4.06407C10.8668 4.10531 10.8257 4.16324 10.8053 4.22941L10.272 5.9894C9.83038 6.11953 9.40465 6.2984 9.00264 6.52274L7.40265 5.65874C7.34085 5.62592 7.27011 5.6139 7.20093 5.62447C7.13176 5.63504 7.06784 5.66763 7.01865 5.71741L5.72266 6.9814C5.67288 7.03058 5.64029 7.09451 5.62972 7.16368C5.61915 7.23286 5.63117 7.30359 5.66399 7.3654L6.52799 8.96539C6.30402 9.3657 6.12515 9.78963 5.99466 10.2294L4.22933 10.7627C4.16316 10.7832 4.10523 10.8242 4.06399 10.8798C4.02274 10.9354 4.00032 11.0028 4 11.072V12.8747C4.00032 12.944 4.02274 13.0113 4.06399 13.0669C4.10523 13.1226 4.16316 13.1636 4.22933 13.184L6.00532 13.7174C6.13724 14.1498 6.31608 14.5665 6.53865 14.96L5.66399 16.6347C5.63117 16.6965 5.61915 16.7672 5.62972 16.8364C5.64029 16.9056 5.67288 16.9695 5.72266 17.0187L6.99732 18.2933C7.0465 18.3431 7.11043 18.3757 7.1796 18.3863C7.24877 18.3968 7.31951 18.3848 7.38132 18.352L9.02931 17.472C9.41915 17.6824 9.83038 17.8504 10.256 17.9733L10.7893 19.7707C10.8097 19.8368 10.8508 19.8948 10.9064 19.936C10.962 19.9773 11.0294 19.9997 11.0986 20H12.9013C12.9705 19.9997 13.0379 19.9773 13.0935 19.936C13.1492 19.8948 13.1902 19.8368 13.2106 19.7707L13.744 17.968C14.1659 17.8445 14.5735 17.6764 14.9599 17.4667L16.6186 18.352C16.6804 18.3848 16.7511 18.3968 16.8203 18.3863C16.8895 18.3757 16.9534 18.3431 17.0026 18.2933L18.2773 17.0187C18.327 16.9695 18.3596 16.9056 18.3702 16.8364C18.3808 16.7672 18.3687 16.6965 18.3359 16.6347L17.4506 14.9814C17.6625 14.5935 17.8324 14.184 17.9573 13.76L19.7546 13.2267C19.8208 13.2063 19.8787 13.1652 19.9199 13.1096C19.9612 13.054 19.9836 12.9866 19.9839 12.9174V11.0987C19.9871 11.0324 19.9698 10.9667 19.9346 10.9105C19.8993 10.8542 19.8477 10.8101 19.7866 10.784ZM12.016 14.9334C11.4358 14.9334 10.8687 14.7613 10.3863 14.439C9.90391 14.1167 9.52794 13.6586 9.30593 13.1226C9.08391 12.5866 9.02582 11.9968 9.139 11.4278C9.25219 10.8588 9.53156 10.3361 9.94179 9.92587C10.352 9.51564 10.8747 9.23627 11.4437 9.12309C12.0127 9.0099 12.6025 9.06799 13.1385 9.29001C13.6745 9.51202 14.1326 9.88799 14.4549 10.3704C14.7772 10.8528 14.9493 11.4199 14.9493 12C14.9493 12.778 14.6402 13.5241 14.0901 14.0742C13.54 14.6243 12.7939 14.9334 12.016 14.9334Z" fill="#868CAC"/>
    </svg>
  `,
  closeModal: `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="cursor-pointer"
    >
      <path
        d="M10.5665 9.99928L17.077 3.48451C17.2337 3.32789 17.2337 3.0739 17.077 2.91727C16.9204 2.76065 16.6664 2.76065 16.5098 2.91727L9.99928 9.43204L3.48451 2.92151C3.32789 2.76488 3.0739 2.76488 2.91727 2.92151C2.76065 3.07813 2.76065 3.33212 2.91727 3.48874L9.43204 9.99928L2.92151 16.514C2.76488 16.6707 2.76488 16.9247 2.92151 17.0813C2.9977 17.1575 3.0993 17.1956 3.20089 17.1956C3.30249 17.1956 3.40408 17.1575 3.48451 17.077L9.99928 10.5665L16.514 17.0813C16.5902 17.1575 16.6961 17.1998 16.7977 17.1998C16.8993 17.1998 17.0008 17.1617 17.0813 17.0813C17.2379 16.9247 17.2379 16.6707 17.0813 16.514L10.5665 9.99928Z"
        fill="#44485E"
      />
    </svg>
  `,
  uploadCreatives: `
    <svg
      class="max-w-full max-h-full"
      width="41"
      height="38"
      viewBox="0 0 41 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 0H24.5C25.5609 0 26.5783 0.421427 27.3284 1.17157C28.0786 1.92172 28.5 2.93913 28.5 4V8H36.5C37.5609 8 38.5783 8.42143 39.3284 9.17157C40.0786 9.92172 40.5 10.9391 40.5 12V34C40.5 35.0609 40.0786 36.0783 39.3284 36.8284C38.5783 37.5786 37.5609 38 36.5 38H4.5C3.43913 38 2.42172 37.5786 1.67157 36.8284C0.921427 36.0783 0.5 35.0609 0.5 34V12C0.5 9.78 2.28 8 4.5 8H12.5V4C12.5 1.78 14.28 0 16.5 0ZM24.5 8V4H16.5V8H24.5ZM20.5 34L30.5 24H24.5V16H16.5V24H10.5L20.5 34Z"
        fill="#868CAC"
      />
    </svg>
  `,
  getImages: `
    <svg
      class="max-w-full max-h-full"
      width="51"
      height="36"
      viewBox="0 0 51 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.506 15.7031C42.8302 14.8672 43.012 13.9531 43.012 13C43.012 8.85938 39.6122 5.5 35.4217 5.5C33.8641 5.5 32.4093 5.96875 31.2075 6.76562C29.0173 3.01562 24.9296 0.5 20.241 0.5C13.2515 0.5 7.59036 6.09375 7.59036 13C7.59036 13.2109 7.59827 13.4219 7.60617 13.6328C3.17846 15.1719 0 19.3438 0 24.25C0 30.4609 5.09977 35.5 11.3855 35.5H40.4819C46.0719 35.5 50.6024 31.0234 50.6024 25.5C50.6024 20.6641 47.1235 16.625 42.506 15.7031ZM31.9981 22.6328L23.6645 30.8672C23.1743 31.3516 22.3678 31.3516 21.8776 30.8672L13.5441 22.6328C12.7455 21.8437 13.3148 20.5 14.4375 20.5H19.6084V11.75C19.6084 11.0625 20.1777 10.5 20.8735 10.5H24.6687C25.3645 10.5 25.9337 11.0625 25.9337 11.75V20.5H31.1047C32.2274 20.5 32.7967 21.8437 31.9981 22.6328Z"
        fill="#868CAC"
      />
    </svg>
  `,
  selectCreatives: `
    <svg
      class="max-w-full max-h-full"
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.483 0.333374C8.28301 0.333374 0.833008 7.80004 0.833008 17C0.833008 26.2 8.28301 33.6667 17.483 33.6667C26.6997 33.6667 34.1663 26.2 34.1663 17C34.1663 7.80004 26.6997 0.333374 17.483 0.333374ZM11.6663 10.3334C13.0497 10.3334 14.1663 11.45 14.1663 12.8334C14.1663 14.2167 13.0497 15.3334 11.6663 15.3334C10.283 15.3334 9.16634 14.2167 9.16634 12.8334C9.16634 11.45 10.283 10.3334 11.6663 10.3334ZM17.4997 27C13.6997 27 10.4663 24.2334 9.16634 20.3334H25.833C24.533 24.2334 21.2997 27 17.4997 27ZM23.333 15.3334C21.9497 15.3334 20.833 14.2167 20.833 12.8334C20.833 11.45 21.9497 10.3334 23.333 10.3334C24.7163 10.3334 25.833 11.45 25.833 12.8334C25.833 14.2167 24.7163 15.3334 23.333 15.3334Z"
        fill="#868CAC"
      />
    </svg>
  `,
  cloneItemDark: `
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.15 8.55H12.35V12.35H10.45V8.55H6.65V6.65H10.45V2.85H12.35V6.65H16.15V8.55ZM17.1 0H5.7C5.19609 0 4.71281 0.200178 4.35649 0.556497C4.00017 0.912812 3.8 1.39609 3.8 1.9V13.3C3.8 13.8039 4.00017 14.2872 4.35649 14.6435C4.71281 14.9998 5.19609 15.2 5.7 15.2H17.1C17.6039 15.2 18.0872 14.9998 18.4435 14.6435C18.7998 14.2872 19 13.8039 19 13.3V1.9C19 1.39609 18.7998 0.912812 18.4435 0.556497C18.0872 0.200178 17.6039 0 17.1 0ZM1.9 3.8H0V17.1C0 17.6039 0.200178 18.0872 0.556497 18.4435C0.912812 18.7998 1.39609 19 1.9 19H15.2V17.1H1.9V3.8Z"
        fill="#868CAC"
      />
    </svg>
  `,
  editItemDark: `
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7441 6.0367C18.0853 5.69549 18.0853 5.12682 17.7441 4.80312L15.6969 2.7559C15.3732 2.4147 14.8045 2.4147 14.4633 2.7559L12.8535 4.35693L16.1343 7.63772L17.7441 6.0367ZM2.25 14.9692V18.25H5.53079L15.207 8.5651L11.9262 5.2843L2.25 14.9692Z"
        fill="#868CAC"
      />
    </svg>
  `,
  editItemLight: `
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="#D4D7E8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6925 4.34413C19.102 3.93469 19.102 3.25229 18.6925 2.86384L16.2359 0.40718C15.8474 -0.00226317 15.165 -0.00226317 14.7556 0.40718L12.8238 2.32841L16.7608 6.26537L18.6925 4.34413ZM0.0996094 15.0631V19.0001H4.03656L15.648 7.37821L11.711 3.44126L0.0996094 15.0631Z"
        fill="#D4D7E8"
      />
    </svg>
  `,
  deleteItemDark: `
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.583 2.66661H13.3955L12.4848 1.74994H7.93122L7.02051 2.66661H3.83301V4.49994H16.583V2.66661ZM4.74372 16.4166C4.74372 16.9028 4.93562 17.3691 5.27721 17.713C5.61879 18.0568 6.08208 18.2499 6.56515 18.2499H13.8509C14.3339 18.2499 14.7972 18.0568 15.1388 17.713C15.4804 17.3691 15.6723 16.9028 15.6723 16.4166V5.41661H4.74372V16.4166Z"
        fill="#868CAC"
      />
    </svg>
  `,
  deleteItemLight: `
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2004 1.2001H12.3754L11.2825 0.100098H5.81825L4.72539 1.2001H0.900391V3.4001H16.2004V1.2001ZM1.99325 17.7001C1.99325 18.2836 2.22353 18.8432 2.63343 19.2557C3.04333 19.6683 3.59927 19.9001 4.17896 19.9001H12.9218C13.5015 19.9001 14.0574 19.6683 14.4674 19.2557C14.8773 18.8432 15.1075 18.2836 15.1075 17.7001V4.5001H1.99325V17.7001Z"
        fill="#D4D7E8"
      />
    </svg>
  `,
  selectAllItems: `
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1.74845e-07C0.895431 1.74845e-07 0 0.895431 0 2V10H3V3H10V1.74845e-07H2Z"
        fill="#D4D7E8"
      />
      <path
        d="M22 2C22 0.895431 21.1046 1.59189e-07 20 1.39876e-07L12 0V3H19V10H22V2Z"
        fill="#D4D7E8"
      />
      <path
        d="M2 22C0.895431 22 0 21.1046 0 20L0 12H3V19H10V22H2Z"
        fill="#D4D7E8"
      />
      <path
        d="M22 20C22 21.1046 21.1046 22 20 22H12V19H19V12H22V20Z"
        fill="#D4D7E8"
      />
    </svg>
  `,
  buttonBack: `
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1765 15.3235L5.82353 9.49996L12.1765 3.67643"
        stroke="black"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
};

export const getIcon = (name: string): TIconSvg => {
  if (!icons[name]) {
    return '';
  }

  return icons[name];
};
